import { defineStore } from "pinia";
import state from "./state";
import actions from "./actions";

export const useListStore = defineStore("list", {
  state,
  actions: actions(),
  persist: {
    enabled: true,
    strategies: [
      {
        key: "list",
        storage: sessionStorage,
        paths: [
          "countries",
          "refer",
          "branches",
          "organizations",
          "services",
          "educationSections",
          "professionalFields",
          "businessSectors",
          "computerSkills",
          "sectors",
          "softSkillTrainings",
          "programs",
          "iscoCodes",
          "thematicAreas",
          "courseTypes",
          "courseSections",
          "programs",
          "emplServices",
          "employmentFields",
          "prevListHashes",
          "listHashes",
          "companySectors",
          "shouldUpdate",
          "likedProfessions",
        ],
      },
    ],
  },
});
